<template>
<div id="covid_totals_table" class="covid_totals_table">
    <div class="widget_container" :class="{'wide': wide}">
        <div v-if="info_open" class="info_window">
            <span class="close" @click="info_open = false">X</span>
            <covid-info :wide="wide"></covid-info>
        </div>
        <div v-if="showHeader" class="red_header">
            <a :href="landing_page_url+query_parameters" :target="landing_page_target" >Novel Coronavirus (COVID-19) Global Fatalities</a>
        </div>
        <div v-if="loading" class="loading"><img src="/images/loading_24w.gif" alt="Loading" /></div>
        <div v-else class="data_table">
            <table class="data large" :class="{'wide': wide}">
                <thead>
                <tr class="header">
                    <th class="country_name" @click="table_sort('country_name', 'string')" :class="current_sort('country_name')">Country</th>
                    <!--<th class="deaths_previous_day" v-if="wide" @click="table_sort('deaths_previous_day')" :class="current_sort('deaths_previous_day')">Previous Day<br>Deaths</th>-->
                    <th @click="table_sort('deaths_pm')" :class="current_sort('deaths_pm')">Deaths /<br>1M <span class="deaths-pop-text" >pop</span></th>
                    <th v-if="wide" class="estimated_cases" @click="table_sort('estimated_cases')" :class="current_sort('estimated_cases')">Total<br>Cases</th><!-- version for table -->
                    <th v-if="!wide && !isIframe" class="estimated_cases" @click="table_sort('estimated_cases')" :class="current_sort('estimated_cases')">Total<br>Cases</th>
                    <!-- version for hp widget but not iframe -->
                    <th v-if="!wide && isIframe" class="new_deaths" @click="table_sort('new_deaths')" :class="current_sort('new_deaths')">New <br>Deaths</th>
                    <th class="confirmed" @click="table_sort('confirmed')" :class="current_sort('confirmed')">Confirmed<br>Cases</th>
                    <th v-if="!wide" class="deaths_p_cases above_phone_portrait" @click="table_sort('deaths_p_cases')" :class="current_sort('deaths_p_cases')">Confirmed Case<br>Fatality Rate</th>
                    <th v-if="wide" @click="table_sort('deaths_p_cases')" :class="current_sort('deaths_p_cases')">Confirmed Case<br>Fatality Rate</th>
                    <th v-if="wide" >Total Case<br>Fatality Rate</th>
                    <!--<th class="actual_fatality_rate above_phone_portrait" @click="table_sort('actual_fatality_rate')" :class="current_sort('actual_fatality_rate')">Actual<br>Fatality Rate</th>-->
                    <!--<th class="new_deaths" @click="table_sort('new_deaths')" :class="current_sort('new_deaths')">New <br>Deaths</th>-->
                    <th class="tests" @click="table_sort('tests')" :class="current_sort('tests')">Tests</th>
                    <th @click="table_sort('tests_pm')" :class="current_sort('tests_pm')">Tests /<br>1M <span class="deaths-pop-text" >pop</span></th>
                    <!--<th class="critical" @click="table_sort('critical')" :class="current_sort('critical')">Serious,<br>Critical</th>-->
                    <!--<th v-if="wide" @click="table_sort('critical_pm')" :class="current_sort('critical_pm')">Critical /<br>1M <span class="deaths-pop-text" >pop</span></th>-->
                    <!--<th v-if="!wide" class="estimated_cases above_phone_portrait" @click="table_sort('estimated_cases')" :class="current_sort('estimated_cases')">Total<br>Cases</th>-->
                    <th v-if="wide" class="confirmed_pm" @click="table_sort('confirmed_pm')" :class="current_sort('confirmed_pm')">Confirmed Cases /<br>1M <span class="deaths-pop-text" >pop</span></th>
                    <!--<th @click="table_sort('h1n1')" :class="current_sort(\'h1n1\')">H1N1 Swine<br>Flu Deaths *</th>-->
                    <th v-if="!wide" class="deaths_p_cases phone_portrait" @click="table_sort('deaths_p_cases')" :class="current_sort('deaths_p_cases')">Confirmed Case<br>Fatality Rate</th>
                    <th v-if="wide" class="new_deaths" @click="table_sort('new_deaths')" :class="current_sort('new_deaths')">New <br>Deaths</th>
                    <th class="deaths" @click="table_sort('deaths')" :class="current_sort('deaths')">Deaths</th>
                    <!--<th v-if="!wide" class="above_phone_portrait" @click="table_sort('influenza_deaths_v2')" :class="current_sort('influenza_deaths_v2')">Seasonal <br v-if="!wide">Flu Deaths<sup>1</sup><br v-if="wide"><span v-if="wide">(CDC/WHO 2017)</span></th>
                    <th v-if="wide" @click="table_sort('influenza_deaths_v2')" :class="current_sort('influenza_deaths_v2')">Seasonal <br v-if="!wide">Flu Deaths<sup>1</sup><br v-if="wide"><span v-if="wide">(CDC/WHO 2017)</span></th>-->
                </tr>
                </thead>
                <tbody v-if="wide" id="global" class="gray-landing-heading" >
                    <tr class="global" >
                        <td class="country_name above_phone_portrait" ></td>
                        <td class="country_name phone_portrait" >Deaths</td>
                        <td class="deaths" v-html="number_format_wrapper_total(table_data.world_total.deaths_total)"></td>
                        <!--<td v-if="wide" class="deaths_previous_day">-</td>-->
                        <!--<td>-</td>-->
                        <td>-</td><!-- Total Cases -->
                        <td>-</td><!-- Confirmed Cases -->
                        <td>-</td><!-- COnfirmed Case Fatality Rate -->
                        <td>-</td><!-- Total Case Fatality Rate -->
                        <!--<td class="critical">-</td>-->
                        <!--<td v-if="wide" v-html="number_format_wrapper(table_data.world_total.critical_pm)"></td>-->
                        <!--<td v-if="!wide" class="estimated_cases above_phone_portrait">-</td>-->
                        <td v-html="number_format_wrapper_total(table_data.world_total.confirmed_total)"></td>
                        <td class="above_phone_portrait estimated_cases">-</td><!-- Test Per 1 Mill Pop -->
                        <!--<td v-if="wide" v-html="number_format(table_data.world_total.deaths_p_cases, 2)+\'%\'"></td>-->
                        <td v-if="wide">-</td><!-- Confirmed Cases 1 Mill Pop -->
                        <td v-if="wide">-</td><!-- Deaths -->
                        <!--<td v-html="number_format_wrapper_total(table_data.world_total.h1n1)"></td>-->
                        <!--<td v-if="!wide" class="deaths_p_cases" v-html="number_format(table_data.world_total.deaths_p_cases, 2)+\'%\'"></td>-->
                        <!--<td v-if="!wide" class="influenza_deaths_v2 above_phone_portrait">-</td>
                        <td v-if="wide" class="influenza_deaths_v2">-</td>-->
                    </tr>
                </tbody>
                <tbody id="per-country" >
                    <template v-for="(country, index) in table_data.countries_total"  >
                        <country-row 
                            :key="country.id"
                            v-if="( 
                                ( (limit == 0 && index < 30) || display_all == true ) 
                                || index < limit )"
                            :country="country"
                            :wide="wide"
                            :is-iframe="isIframe"
                        >
                        </country-row>
                    </template>
                </tbody>
                <tfoot>
                    <tr v-if="!wide" class="bottom_link" :class="{'alt': footer_alt(0)}">
                        <td :colspan="full_table_colspan()">
                            <a :href="landing_page_url+query_parameters" :target="landing_page_target" >Full Global List of Coronavirus Fatalities</a> <span class="info" @click="info_open = true">&#x1F6C8;</span>
                        </td>
                    </tr>
                    <template v-else>
                        <template v-for="(country, index) in bottom_countries" >
                            <country-row 
                                :key="country.id"
                                v-if="display_all" 
                                :class="{'alt': footer_alt(0)}"
                                :country="country"
                                :wide="wide"
                            >
                            </country-row>
                        </template>
                        <tr class="bottom_info" v-if="display_all === false">
                            <template v-if="window_width <= 666" >
                                <td :colspan="view_all_mobile_td_cols.button" class="view-all-td"  >
                                    <button type="button" class="display-all-btn"
                                        @click="display_all_countries()" 
                                        >View All</button>
                                </td>
                                <td :colspan="view_all_mobile_td_cols.filler" >
                                </td>
                            </template>
                            <template v-else >
                                <td :colspan="full_table_colspan()" class="view-all-td"  >
                                    <button type="button" class="display-all-btn"
                                        @click="display_all_countries()" 
                                        >View All</button>
                                </td>
                            </template>
                        </tr>
                        <tr class="bottom_info" v-else :class="{'alt': footer_alt(0)}">
                            <td :colspan="full_table_colspan()">
                                <covid-info :wide="wide"></covid-info>
                            </td>
                        </tr>
                    </template>
                </tfoot>
            </table>
        </div>
    </div>
</div>
</template>

<script>

const CountryRow = () => import(/* webpackChunkName: "CovidCountryRow" */ "./CountryRow.vue");
const CovidInfo = () => import(/* webpackChunkName: "CovidCovidInfo" */ "./CovidInfo.vue");

import CovidMixin from './CovidMixin.js';

export default {
    name: 'covid-totals-table',
    components: {
        'country-row': CountryRow,
        'covid-info': CovidInfo,
    },
    mixins: [
        CovidMixin,
    ],
    props: {
        showHeader: {
            type: Boolean,
            default: true,
        },
        limit: {
            type: Number,
            default: 0,
        },
        wide: {
            type: Boolean,
            default: false,
        },
        isIframe: {
            type: Boolean,
            default: false,
        },
        whitelist: {
            type: Array,
            default: function() {
                return [];
            },
        },
        blacklist: {
            type: Array,
            default: function() {
                return [];
            },
        },
    },
    data : function() {
        return {
            loading: true,
            info_open: false,
            cache_bust : Math.floor((new Date()).getTime() / 25000), // Changes every 25 seconds
            table_data : {},
            promises : [],
            sort_col : '',
            sort_type : '',
            alt_country_names : {
                "USA" : "<span class='above_phone_portrait'>United States</span><span class='phone_portrait'>U.S.</span>",
                "S. Korea" : "South Korea",
                "UK" : "<span class='above_phone_portrait'>United Kingdom</span><span class='phone_portrait'>U.K.</span>",
                "China" : "China*",
                "Iran": "Iran**",
            },
            bottom_country_names: [
                "Diamond Princess",
                "Channel Islands",
                "San Marino",
                "Cayman Islands",
                "Saint Martin",
                "Monaco",
                "Andorra",
                "Guadeloupe",
                "CuraÃ§ao",
                "Cabo Verde",
                "Mayotte",
                "Sint Maarten",
                "Isle of Man",
                "Bermuda",
                "British Virgin Islands",
                "Martinique",
                "Antigua and Barbuda",
                "Turks and Caicos",
                "Liechtenstein",
                "Bahamas",
                "Guyana",
                "Curaçao",
                "Malta",
                "Ivory Coast",
                "Mauritania",
                "Burundi",
                "Benin",
                "Angola",
                "Congo", 
            ],
            bottom_countries : [],
            landing_page_url: '/coronavirus/',
            display_all: false,

            window_width: 0,
        };
    },
    created : function() {
        this.load_json();

        this.set_window_width();
        window.addEventListener('resize', this.set_window_width);
    },
    computed: {

        landing_page_target: function(){

            if(this.isIframe){
                return '_top';
            }

            return '_self';
        },

        query_parameters: function(){

            if(this.isIframe){
                return '?'+this.get_partners_utm_string();
            }

            return '';
        },

        view_all_mobile_td_cols: function(){
            
            if( this.window_width <= 374){
                return {button: 3, filler: 6};
            }

            if( this.window_width <= 500){
                return {button: 4, filler: 5};
            }

            return {button: 5, filler: 4};
        },

    },
    methods: {

        set_window_width: function(){
            this.window_width = window.innerWidth;
        },

        display_all_countries: function(){
            this.display_all = true;
        },

        clone : function(obj) {
        return JSON.parse(JSON.stringify(obj));
        },

        full_table_colspan : function() {
            return this.wide ? 12 : 8;
        },

        footer_alt : function(offset) {

            var item_count = this.limit;
            if(item_count == 0) {
                item_count = this.table_data.countries_total.length;
            }
            item_count += offset;
            if( (item_count == 0 || item_count % 2) == 0 ) {
                return false;
            } else {
                return true;
            }
        },

        current_sort : function(sort_str) {

            if(this.sort_col == sort_str) {
                return this.sort_type;
            } else {
                return '';
            }
        },

        table_sort : function(sort_str, data_type) {

            if(typeof data_type === 'undefined') {
                data_type = 'number';
            }

            if(this.sort_col == sort_str) {
                if(this.sort_type == 'desc') {
                    this.sort_type = 'asc';
                } else {
                    this.sort_type = 'desc';
                }
            } else {
                this.sort_type = 'desc';
            }

            this.sort_col = sort_str;

            this.table_data.countries_total.sort(function(a, b) {
                var first = a;
                var second = b;
                if(this.sort_type == 'asc') {
                    first = b;
                    second = a;
                }

                if(data_type == 'string') {
                    return first[this.sort_col].localeCompare(second[this.sort_col]);
                } else {
                    return first[this.sort_col] < second[this.sort_col] ? 1 : -1;
                }
            }.bind(this));
        },

        load_json : function() {

            this.promises.push(axios({
                method: 'get',
                url: '/json/covid/country_totals.json?cache_bust='+this.cache_bust
            }));

            axios.all(this.promises)
            .catch(function(error) {
                console.log(error);
            })
            .then(function(results) {

                results.forEach(function(r, i_r) {

                    this.load_totals(r);

                }.bind(this));
            }.bind(this));
        },

        load_totals : function(r) {

            this.table_data = r.data;

            /**
             * Remove any black listed country, if any.
             */
            if(this.blacklist.length > 0){

                for (let i = 0; i < this.blacklist.length; i++) {
                    var country_name = this.blacklist[i];
                    var country_index = this.table_data.countries_total.map(function(x){
                        return x.country_name;
                    }).indexOf(country_name);

                    if(country_index > -1){
                        this.table_data.countries_total.splice(country_index, 1);
                    }
                }

            }

            // filter to whitelist if whitelist applied
            if(this.whitelist.length > 0) {

                var wl_countries = this.table_data.countries_total.filter(function(country, c_index) {
                    return this.whitelist.indexOf(country.country_name) > -1;
                }.bind(this));
                this.table_data.countries_total = wl_countries;
            }

            // filter to limit if limit applied
            // Removed to make limit just on what's shown, to improve sorting logic on HP widget
            /*if(this.limit > 0) {

                var limit_countries = this.table_data.countries_total
                .sort(function(a, b){

                    // push bottom country names to the bottom of the sort by returning 0
                    if( this.bottom_country_names.indexOf(a.country_name) > -1 ){
                        return 0;
                    }

                    // else return the normal sort
                    return parseFloat(b.deaths_pop_ratio) - parseFloat(a.deaths_pop_ratio);
                }.bind(this));

                limit_countries = limit_countries.filter(function(country, c_index) {
                    if(c_index < this.limit){
                        return country;
                    }
                }.bind(this));

                this.table_data.countries_total = limit_countries;
            }*/

            // Only show row if one death or higher
            var death_countries = this.table_data.countries_total.filter(function(country) {
                return country.deaths >= 1;
            }.bind(this));
            this.table_data.countries_total = death_countries;

            // Find index of diamond princess
            /*this.diamond_princess_index = this.table_data.countries_total.findIndex(function(country) {
                return country.country_name == 'Diamond Princess';
            });*/

            // add some custom calculations in data
            this.table_data.countries_total.forEach(function(country){

                country.deaths_p_cases  = (country.deaths / country.confirmed) * 100;

                if( country.population !== null ){

                    country.confirmed_pm = Math.round((country.confirmed / country.population) * 1000000);
                    country.deaths_pm    = Math.round((country.deaths / country.population) * 1000000);
                    country.recovered_pm = Math.round((country.recovered / country.population) * 1000000);
                    country.critical_pm  = Math.round((country.critical / country.population) * 1000000);
                    country.tests_pm     = Math.round((country.tests / country.population) * 1000000);

                    country.confirmed_p = Math.round((country.confirmed / country.population) * 100);
                    country.deaths_p    = Math.round((country.deaths / country.population) * 100);
                    country.recovered_p = Math.round((country.recovered / country.population) * 100);
                    country.critical_p  = Math.round((country.critical / country.population) * 100);
                    country.tests_p     = Math.round((country.tests / country.population) * 100);

                    /*country.confirmed_pm  = parseFloat(country.confirmed_pop_ratio) * 1000000;
                    country.deaths_pm     = parseFloat(country.deaths_pop_ratio) * 1000000;
                    country.recovered_pm  = parseFloat(country.recovered_pop_ratio) * 1000000;
                    country.critical_pm   = parseFloat(country.critical_pop_ratio) * 1000000;

                    country.confirmed_p = parseFloat(country.confirmed_pop_ratio) * 100;
                    country.deaths_p    = parseFloat(country.deaths_pop_ratio) * 100;
                    country.recovered_p = parseFloat(country.recovered_pop_ratio) * 100;
                    country.critical_p  = parseFloat(country.critical_pop_ratio) * 100;*/
                
                } else {

                    country.confirmed_pm = 0;
                    country.deaths_pm    = 0;
                    country.recovered_pm = 0;
                    country.critical_pm  = 0;
                    country.tests_pm     = 0;

                    country.confirmed_p = 0;
                    country.deaths_p    = 0;
                    country.recovered_p = 0;
                    country.critical_p  = 0;
                    country.tests_p     = 0;
                }

                // Differentiate between 0 for critical, and no critical supplied
                if(country.critical == null) {

                    country.critical_pm = null;
                    country.critical_p  = null;
                }

                if(country.tests == null) {

                    country.tests_pm = null;
                    country.tests_p  = null;
                }

                // Filter country names
                if( typeof this.alt_country_names[country.country_name] !== 'undefined' ) {
                    country.country_name = this.alt_country_names[country.country_name];
                }
            }.bind(this));

            // remove bottom countries and save into bottom_countries array

            this.bottom_countries = this.table_data.countries_total.filter(function(country) {
                return this.bottom_country_names.indexOf(country.country_name) > -1;
            }.bind(this));

            this.table_data.countries_total = this.table_data.countries_total.filter(function(country) {
                return this.bottom_country_names.indexOf(country.country_name) === -1;
            }.bind(this));

            // calculate global numbers

            this.table_data.world_total.confirmed_pm   = (this.table_data.world_total.confirmed_total / this.table_data.world_total.population_total) * 1000000;
            this.table_data.world_total.deaths_pm      = (this.table_data.world_total.deaths_total / this.table_data.world_total.population_total) * 1000000;
            this.table_data.world_total.critical_pm   = (this.table_data.world_total.critical_total / this.table_data.world_total.population_total) * 1000000;
            this.table_data.world_total.deaths_p_cases = (this.table_data.world_total.deaths_total / this.table_data.world_total.confirmed_total) * 100;

            // default sort by Deaths Per Million
            this.table_sort('deaths_pm');

            this.loading = false;
        },

    },
}
</script>